import { Box } from '@mui/material'
import { taskSearchFilters } from 'components/core/task/TaskSearchFilter'
import { TaskListColumnsV2, TaskListV2 } from 'components/core/task-list-v2/TaskListV2'
import { ReactElement } from 'react'

type TasksForUserProps = {
    userId: string
}

const cols = [
    TaskListColumnsV2.viewLink,
    TaskListColumnsV2.account,
    TaskListColumnsV2.entitlement,
    TaskListColumnsV2.actions,
]

const displayFilters: taskSearchFilters = [
    'query',
    'opener',
    'app',
    'type',
    'status',
    'assignee',
    'resource-type',
    'older-than',
]

export const TasksForUser = ({ userId }: TasksForUserProps): ReactElement | null => {
    return <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            overflow: 'auto',
            maxHeight: 'calc(100vh - 260px)',
        }}
    >
        <TaskListV2
            filter={{
                subjectIds: [userId],
            }}
            columns={cols}
            displayFilters={displayFilters}
            allowExport
        />
    </Box>
}
